import React from 'react';
import CompanyLogos from '../components/CompanyLogos';
import CoursesSection from '../components/CoursesSection';
import TutorSection from '../components/TutorSection';
import AboutUs from '../components/AboutUs';
import ContactSection from '../components/ContactSection';
import ReviewsSection from '../components/ReviewsSection';
import SkillToDeploy from '../components/SkillToDeploy';
import CareerChavdiSection from '../components/CareerChavdiSection';
import HeroSection from '../components/HeroSection';

const Home = () => {
  return (
    <div className="flex flex-col gap-12 pb-12">
      <HeroSection />
      <CompanyLogos />
      <CoursesSection />
      <SkillToDeploy />
      <CareerChavdiSection />
      <TutorSection />
      <AboutUs />
      <ReviewsSection />
      <ContactSection />
    </div>
  );
};

export default Home;
